import React, { useCallback, useMemo, useState } from "react";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import Adsense from "./Adsense.js";
import useHideBanners from "./useHideBanners.js";
import useAdBlockerCheck from "./helpers/useAdBlockerCheck.ts";

const ClosableAdsense = ({ bannerPosition, size = {} }) => {
  const [closeAd, setCloseAd] = useState(false);
  const [counter, setCounter] = useState(5);

  //here will add logic about if user have to see ads
  const userIsPro = useHideBanners();

  // const interval = useRef();

  const Advertising = useCallback(() => {
    if (!userIsPro && !closeAd) {
      // if (!interval.current) {
      //   interval.current = setInterval(() => {
      //     if (counter > 0) {
      //       setCounter((count) => count - 1);
      //     }
      //   }, 1000);
      // }
      document.body.classList.add("stop-scroll");
      setTimeout(() => {
        setCloseAd(true);
        document.body.classList.remove("stop-scroll");
      }, 7000);
      return (
        <Adsense bannerPosition={bannerPosition} isMobile={true} size={size} />
      );
    }
    return null;
  }, [userIsPro, closeAd]);

  const clickHandeler = () => {
    // if (counter > 0) return;
    setCloseAd(true);
    document.body.classList.remove("stop-scroll");
  };

  // useEffect(() => {
  //   if (counter < 1) {
  //     clearInterval(interval.current);
  //   }
  // }, [counter]);

  //render
  const isAdBlockerEnabled = useAdBlockerCheck();

  if (isAdBlockerEnabled) {
    return null;
  }

  return !userIsPro ? (
    <AnimationContainer animationOn={!closeAd} animationClassName="fade-in">
      <Advertising />
      <div className="ad-close-header" onClick={clickHandeler}>
        <div className="ad-close-button">X</div>
        {/* <div className="ad-close-logo">
              <Image name={"jumbomail-logo-small"} />
            </div> */}
      </div>
    </AnimationContainer>
  ) : null;
};

export default ClosableAdsense;
